// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mm4Yx","right":"styles_right__1LIyC"};